import React, { useEffect, useRef } from "react";
import "./index.scss";
import { client, ROUTE, ROUTE_TITLE } from "./Components/misc";
import { BrowserRouter as Router, Route, Switch, useLocation } from "react-router-dom";

import { PageTemplate } from "./Components/Structure";
import { PageMainTab, PageMainTabValue } from "./Components/PageMainTab";

import "./App.scss";
import { ApolloProvider } from "@apollo/client";
import { BasicAuth, EnvironmentReader } from "./Components/BasicAuth";
import { event as pageVisitEvent } from "./Components/GA/PageVisit/PageVisit";
import { GoogleReCaptchaProvider } from "react-google-recaptcha-v3";
import { Config } from "./Config";
// import { HorizontalTwoLineLabelDemo } from "./Components/HorizontalTwoLineLabel";

// import { BrowserRouter as Router, Route, Switch } from "react-router-dom";

// need a list of providers, query string, size options, region options
interface AppWithoutRouteProps {
    activeTabId: PageMainTabValue;
    exploreDisplayOption?: "search" | "providerInfo" | "providerSelectToCompare" | "providerCompare";
}

const AppWithoutRoute: React.FC<AppWithoutRouteProps> = ({ activeTabId, exploreDisplayOption }) => {
    const { search, pathname } = useLocation();
    const previousPath = useRef({
        pathname: null,
        search: null
    });

    useEffect(() => {
        const curentPath = `${pathname}${search ?? ""}`;
        const _previousPath =
            previousPath.current?.pathname == null
                ? null
                : `${previousPath?.current?.pathname ?? ""}${previousPath?.current?.search ?? ""}`;

        pageVisitEvent(
            activeTabId === "overview"
                ? "home"
                : activeTabId === "faq"
                ? "faq"
                : activeTabId === "about"
                ? "about"
                : exploreDisplayOption === "search"
                ? "exploreProviders"
                : exploreDisplayOption === "providerInfo"
                ? "providerInfo"
                : exploreDisplayOption === "providerSelectToCompare"
                ? "providerSelectToCompare"
                : exploreDisplayOption === "providerCompare"
                ? "providerComparison"
                : "home",
            curentPath,
            previousPath.current.pathname,
            _previousPath
        );

        previousPath.current.pathname = pathname;
        previousPath.current.search = search;
    }, [
        activeTabId,
        exploreDisplayOption,
        pathname,
        search,
        previousPath.current.pathname,
        previousPath.current.search
    ]);

    useEffect(() => {
        // find footer if exists, and display it after authentication
        const footer = document.querySelector(".site-footer") as HTMLDivElement;

        if (footer) {
            footer.style.opacity = "1";
        }
    }, []);

    return (
        <PageTemplate>
            <div className="row">
                <div className="col-12 p-0">
                    <PageMainTab activeTabId={activeTabId} exploreDisplayOption={exploreDisplayOption} />
                </div>
            </div>
        </PageTemplate>
    );
};

export const GoogleReCaptchaProviderWrapper: React.FC = ({ children }) => {
    if (Config.captchaSiteKey == null || Config.captchaSiteKey.trim() === "") return null;

    console.log("Captcha", Config);
    return <GoogleReCaptchaProvider reCaptchaKey={Config.captchaSiteKey}>{children}</GoogleReCaptchaProvider>;
};

export const App: React.FC<{}> = () => {
    return (
        <EnvironmentReader>
            <BasicAuth>
                <GoogleReCaptchaProviderWrapper>
                    <ApolloProvider client={client}>
                        <Router>
                            <Switch>
                                <Route
                                    path={ROUTE.HOME}
                                    exact
                                    render={___ => {
                                        document.title = ROUTE_TITLE.HOME;
                                        return <AppWithoutRoute activeTabId="overview" />;
                                    }}
                                />
                                <Route
                                    path={ROUTE.FAQ}
                                    exact
                                    render={___ => {
                                        document.title = ROUTE_TITLE.FAQ;
                                        return <AppWithoutRoute activeTabId="faq" />;
                                    }}
                                />
                                <Route
                                    path={ROUTE.ABOUT}
                                    exact
                                    render={___ => {
                                        document.title = ROUTE_TITLE.ABOUT;
                                        return <AppWithoutRoute activeTabId="about" />;
                                    }}
                                />
                                <Route
                                    path={ROUTE.SEARCH_PAGE}
                                    exact
                                    render={___ => {
                                        document.title = ROUTE_TITLE.SEARCH_PAGE;
                                        return <AppWithoutRoute activeTabId="explore" exploreDisplayOption="search" />;
                                    }}
                                />
                                <Route
                                    path={ROUTE.PROVIDER_INFO}
                                    exact
                                    render={___ => {
                                        document.title = ROUTE_TITLE.PROVIDER_INFO;
                                        return (
                                            <AppWithoutRoute
                                                activeTabId="explore"
                                                exploreDisplayOption="providerInfo"
                                            />
                                        );
                                    }}
                                />
                                <Route
                                    path={ROUTE.PROVIDER_SELECT_TO_COMPARE}
                                    exact
                                    render={___ => {
                                        document.title = ROUTE_TITLE.PROVIDER_SELECT_TO_COMPARE;
                                        return (
                                            <AppWithoutRoute
                                                activeTabId="explore"
                                                exploreDisplayOption="providerSelectToCompare"
                                            />
                                        );
                                    }}
                                />
                                <Route
                                    path={ROUTE.PROVIDER_COMPARE}
                                    exact
                                    render={___ => {
                                        document.title = ROUTE_TITLE.PROVIDER_COMPARE;
                                        return (
                                            <AppWithoutRoute
                                                activeTabId="explore"
                                                exploreDisplayOption="providerCompare"
                                            />
                                        );
                                    }}
                                />
                                <Route
                                    render={___ => {
                                        document.title = ROUTE_TITLE.HOME;
                                        return <AppWithoutRoute activeTabId="overview" />;
                                    }}
                                />
                            </Switch>
                        </Router>
                    </ApolloProvider>
                </GoogleReCaptchaProviderWrapper>
            </BasicAuth>
        </EnvironmentReader>
    );
};
